export enum ErrorMessages {
  OPERATION_NOT_ALLOWED_FOR_PARTNER = "Operation is not allowed for partner",
}
